import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { openCalendly, prefetchCalendly } from '../utils/loadCalendly';
import '../styles/Header.css';

const NAV_ITEMS = [
  { id: 'capabilities', label: 'Capabilities' },
  { id: 'process', label: 'Process' },
  { id: 'case-studies', label: 'Results' },
  { id: 'about', label: 'About' },
  { id: 'faq', label: 'FAQ' },
];

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string): void => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleBookCall = (): void => {
    void openCalendly();
  };

  return (
    <header className={`header ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="container header-content">
        <a
          href="#home"
          className="logo"
          onClick={(e) => scrollToSection(e, 'home')}
          aria-label="Datryx — home"
        >
          <span className="logo-mark" aria-hidden="true">
            <span className="logo-dot" />
            <span className="logo-dot" />
            <span className="logo-dot" />
            <span className="logo-dot" />
          </span>
          <span className="logo-word">Datryx</span>
        </a>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`} aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <a key={item.id} href={`#${item.id}`} onClick={(e) => scrollToSection(e, item.id)}>
              {item.label}
            </a>
          ))}
          <button
            className="btn-primary btn-header-mobile"
            onClick={handleBookCall}
            onMouseEnter={prefetchCalendly}
          >
            Book a call
          </button>
        </nav>

        <button
          className="btn-primary btn-header"
          onClick={handleBookCall}
          onMouseEnter={prefetchCalendly}
        >
          Book a call
        </button>

        <button
          className="mobile-toggle"
          onClick={() => setIsMenuOpen((v) => !v)}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
